module.exports = __webpack_public_path__ + "static/4-2d95d492e1dc9fdaf2482753373ad058.jpg";